import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {
    Button,
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
  } from "reactstrap";

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import { Wrapper, Content , ContentRow} from './ListConfigs.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListConfigs extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.assessmentToggle = this.assessmentToggle.bind(this);
        this.assessmentSubmit =  this.assessmentSubmit.bind(this);
        this.uploadToggle = this.uploadToggle.bind(this);
        this.uploadSubmit = this.uploadSubmit.bind(this);
        this.autogenCourses = this.autogenCourses.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public uploadToggle() {
        const data = this.state.data;
        data.uploadModal = !data.uploadModal;
    
        console.log(data.uploadModal);
    
        this.setState({ data });
    }

    public async autogenCourses() {
        const res = await this.props.services.adminAPI.initAutogenCourses();
    
        if (res.ok) {
          const data = this.state.data;
    
          data.uploading = false;
    
          data.uploadModal = false;
    
          this.setState({ data });
    
          toast.success("Success");
        }

        else {
            toast.error("Error occurred")
        }
    }

    public async uploadSubmit(e) {
        e.preventDefault();
    
        const data = this.state.data;
    
        data.uploading = true;
    
        this.setState({ data });
    
        const fileInputElement = e.target.elements.upld;
        const formData = new FormData();
    
    
        for (const row of fileInputElement.files) {
          formData.append("files", row);
        }
        
        console.log('FOrmData: ' + formData, null, 2);

        const res = await this.props.services.adminAPI.updloadAutoRecommenderConfig(formData);
    
        if (res.ok) {
          const data = this.state.data;
    
          data.uploading = false;
    
          data.uploadModal = false;
    
          this.setState({ data });
    
          toast.success("Success");
    
          if (res.ok) {
                    
            const assetCollectionsRes = await this.props.services. adminAPI.getAutorecommenderConfigs();

            if (assetCollectionsRes.ok) {
    
                const collections = assetCollectionsRes.data.configs;
                
                const data = this.state.data;

                data.collections = collections;

                this.setState({data});
            }
            
            }
        } else {
          toast.error("Failed to complete upload");
        }
    
        data.uploading = false;
    
        this.setState({ data });
      }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'singleassessment/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async delete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral('autorecommender',row.rowData.id);
                  if (res.ok) {
                    
                    const assetCollectionsRes = await this.props.services. adminAPI.getAutorecommenderConfigs();

                    if (assetCollectionsRes.ok) {
            
                        const collections = assetCollectionsRes.data.configs;
                        
                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.delete(props)}>Delete Config</button>
          </td>
        );
    } 

    public assessmentToggle() {
        const data = this.state.data
        data.assessmentModal = !data.assessmentModal;
        this.setState({
            data
         });
    }

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title", "Module1", "Module2", "Module3","Module4", "UserLevel", "AlertLevel","IsEnabled", "delete"];
        
        const assetCollectionsThead = ["id", "Title", "Module1", "Module2", "Module3","Module4", "UserLevel", "AlertLevel","IsEnabled", "Action"];

        const assessmentFormValues = {
            AssessmentVersion: '',
            User: currentUserID,
            Name: '',
            isPreAssessment: false,
            Enabled: false,
            TargetGroup: '',
            Ploa_Level: ''
        }

        const [configsRes, levelsRes] = await Promise.all([adminAPI.getAutorecommenderConfigs(), adminAPI.getUserLevels()])

        if (configsRes.ok) {

            const assessmentFormFields = [
                {
                    id: 'AssessmentVersion',
                    name: 'AssessmentVersion',
                    type: 'option',
                    placeholder: 'Enter Version',
                    options: {
                        items: [
                            {'Name': '0.5'},
                            {'Name': '1.0'}
                        ],
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Name'
                    },
                    required: true
                },
                {
                    id: 'isPreAssessment',
                    name: 'isPreAssessment',
                    type: 'option',
                    placeholder: 'PreAssessment',
                    options: {
                        items: [
                            {'Name': 'yes', 'Value': true},
                            {'Name': 'no', 'Value': false}
                        ],
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Value'
                    },
                    required: true
                },
                {
                    id: 'Ploa_Level',
                    name: 'Ploa_Level',
                    type: 'option',
                    placeholder: 'Level',
                    options: {
                        items: levelsRes.data,
                        idkey: 'Name',
                        labelkey: 'Name',
                        valuekey: 'Name'
                    },
                    required: true
                },
                {
                    id: 'Name',
                    name: 'Name',
                    type: 'text',
                    placeholder: 'Enter Name',
                    required: true
                },
                {
                    id: 'Description',
                    name: 'Description',
                    type: 'text',
                    placeholder: 'Enter Description',
                    required: true
                }
    
            ] as FormFieldClass[];
            
            const collections = configsRes.data.configs;

            this.setState(
                {
                     data: {
                        assessmentFormFields,
                        assessmentFormValues,
                        assessmentModal: false,
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead,
                        uploading: false,
                        uploadModal: false,
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public async assessmentSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

        const item = this.state.data.assessmentFormValues;

        const res = await this.props.services.adminAPI.createItemGeneral('assessments', item);

        if (res.ok) {
            this.assessmentToggle();

            const assessmentsRes = await this.props.services.adminAPI.getAssessments();
            
            if(assessmentsRes.ok) {
                const data = this.state.data;

                data.collections = assessmentsRes.data.assessments;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>

                <Button onClick={this.uploadToggle} style={{marginLeft: '3px', marginRight: '3px'}}>Upload Csv</Button>

                <Button onClick={this.autogenCourses} style={{marginLeft: '3px', marginRight: '3px'}}>Autogenerate Courses</Button>


                <a href="https://plexdata.s3.eu-west-2.amazonaws.com/samples/autorecommender_template.csv" target="_blank">Download Template</a>

                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              <ContentRow>
             
              <Modal
                isOpen={data.uploadModal}
                toggle={this.uploadToggle}
                style={{ marginTop: "10%" }}
                >
                <ModalHeader toggle={this.uploadToggle}> CSV Upload</ModalHeader>
                <ModalBody>
                    <form onSubmit={this.uploadSubmit}>
                        <Row>
                        <Col xs="12">
                            <input
                                id="upld"
                                type="file"
                                name="upld"
                                accept=".csv"
                                multiple={true}
                                required={true}
                            />
                        </Col>
                        <br />
                        <br />

                        <Loader color="#3EE9F7" loaded={!data.uploading}>
                        <Button
                            color="primary"
                            type="submit"
                            className="adminmodalbutton"
                            >
                            Submit
                            </Button>
                            <Button
                                onClick={this.uploadToggle}
                                className="adminmodalbutton"
                            >
                            Cancel
                            </Button>
                        </Loader>
                        </Row>
                    </form>
                    </ModalBody>
                </Modal>
                    
                </ContentRow>

              
              </Wrapper>
        );

    }

}

export default withServices(ListConfigs);


// WEBPACK FOOTER //
// ./src/pages/Admin/Autorecommender/ListConfigs/ListConfigs.tsx